<template>
  <div :id="componentId" class="introduction-block">
    <h3 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="introduction-pre-title">
      {{ initialdata.range }}
    </h3>
    <h1 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="introduction-title">
      {{ initialdata.product_title }}
    </h1>
    <h2 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="introduction-sub-title">
      {{ initialdata.sub_title }}
    </h2>
    <carousel :per-page="1" :carousel-identifier="carouselIdentifier" :slide-padding="12">
      <slide v-if="initialdata.first_image">
        <img
          :src="initialdata.first_image.Src"
          :alt="initialdata.first_image.Alt"
          class="intro-block-image-slides"
        />
      </slide>
      <slide v-if="initialdata.second_image">
        <img
          :src="initialdata.second_image.Src"
          :alt="initialdata.second_image.Alt"
          class="intro-block-image-slides"
        />
      </slide>
      <slide v-if="initialdata.third_image">
        <img
          :src="initialdata.third_image.Src"
          :alt="initialdata.third_image.Alt"
          class="intro-block-image-slides"
        />
      </slide>
    </carousel>
    <slot name="description"></slot>
    <slot name="list-description"></slot>
    <p v-if="initialdata.final_text" class="note-small-text">{{ initialdata.final_text }}</p>
  </div>
</template>

<script>
export default {
  name: 'introduction-block',
  props: {
    initialdata: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      carouselIdentifier: `carousel-${Date.now()}`,
      componentId: 'product',
    };
  },
  mounted() {
    if (this.initialdata.color_code) {
      document.documentElement.style.setProperty(
        '--carousel-dot-color',
        this.initialdata.color_code,
      );
    }
    document.addEventListener('scroll', this.menuHighlight);
    this.dataLayerobj = dataLayer[0];
    dataLayer.push({
      brand: this.dataLayerobj['brand'],
      country: this.dataLayerobj['country'],
      siteTypeLevel: this.dataLayerobj['siteTypeLevel'],
      language: this.dataLayerobj['language'],
      cid: this.dataLayerobj['cid'],
      pageCategory: 'content page::augmented products',
    });
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
  },
};
</script>
